<template>
	<div class="unitDetail">
		<NavHeader title="单位登记" />
		<van-tabs swipeable @click="tabClick">
			<van-tab title="单位信息">
				<van-cell-group>
					<!-- <van-field v-model="obj.contractNo" required label="合同编号:" placeholder="请输入合同编号" :error-message="errorMsg.contractNo"
					 :readonly="readonly" />
					<van-field v-model="obj.contractStime" required label="开始时间:" placeholder="请选择开始时间" :error-message="errorMsg.contractStime"
					 :readonly="true" @click="stimeshow=true" />
					<van-field v-model="obj.contractEtime" required label="结束时间:" placeholder="请选择结束时间" :error-message="errorMsg.contractEtime"
					 :readonly="true" @click="etimeshow=true" />
					<van-field v-model="businessType" required label="业务类型:" placeholder="请选择业务类型" :error-message="errorMsg.businessType"
					 :readonly="true" @click="typeshow=true" /> -->
					<van-field v-model="obj.orgName" required label="单位名称:" placeholder="请输入单位名称" :error-message="errorMsg.orgName"
					 :readonly="readonly" />
					<van-field v-model="obj.orgAddr" required label="单位地址:" placeholder="请输入单位地址" :error-message="errorMsg.orgAddr"
					 :readonly="readonly" />
					<van-field v-model="obj.orgCode" required label="组织机构代码:" placeholder="请输入组织机构代码" :error-message="errorMsg.orgCode"
					 :readonly="true" />
					<van-field v-model="obj.representative" required label="法人代表:" placeholder="请输入法人代表" :error-message="errorMsg.representative"
					 :readonly="true" />
					<van-field v-model="obj.person" required label="联系人:" placeholder="请输入联系人" :error-message="errorMsg.person"
					 :readonly="readonly" />
					<van-field v-model="obj.phone" required label="手机号:" placeholder="请输入手机号" :error-message="errorMsg.phone"
					 :readonly="readonly" />
					<van-field v-model="obj.businessIntro" label="业务说明:" placeholder="请输入业务说明" type="textarea" rows="3" :readonly="readonly" />
					<van-field v-model="obj.businessScope" label="经营范围:" placeholder="请输入经营范围" type="textarea" rows="3" :readonly="readonly" />
				</van-cell-group>
				<van-button class="collect-submit" v-if="!readonly" @click="submitInfo">保存</van-button>
			</van-tab>
			<van-tab title="单位资质">
				<van-cell-group>
					<van-row>
						<van-cell v-for="(todo, index) in types" :key="index">
							<template #title>
								<span><i>*</i>{{todo.id}}、{{todo.name}}</span>
							</template>
							<template #default>
								<span v-show="fileObj[todo.id]!=null" style="margin-right: 6px;" @click="lookFlie(fileObj[todo.id].id)">查看</span>
								<van-uploader v-if="!readonly" accept="image/jpg, image/jpeg" :name="todo.id" :after-read="onRead">
									<span>上传文件</span>
								</van-uploader>
							</template>
						</van-cell>
					</van-row>
				</van-cell-group>
				<van-button class="collect-submit" v-if="!readonly" @click="submitFile">提交</van-button>
			</van-tab>
		</van-tabs>


		<van-image-preview v-model="imgshow" :images="images"></van-image-preview>
		<van-popup v-model="stimeshow" position="bottom" :overlay="true">
			<van-datetime-picker type="date" :min-date="new Date()" @confirm="stimeconfirm" @cancel="stimeshow=false" :formatter="formatter" />
		</van-popup>
		<van-popup v-model="etimeshow" position="bottom" :overlay="true">
			<van-datetime-picker type="date" :min-date="new Date()" @confirm="etimeconfirm" @cancel="etimeshow=false" :formatter="formatter" />
		</van-popup>
		<van-popup v-model="typeshow" position="bottom" :overlay="true">
			<van-picker show-toolbar title="业务类型" :columns="typeColumns" @confirm="typeconfirm" @cancel="typeshow=false" />
		</van-popup>
	</div>

</template>

<script>
	import NavHeader from '../../components/header/nav-header.vue'
	import {
		validateForm,
		isMobile,
	} from '../../components/utils/validate.js'
	export default {
		data() {
			return {
				readonly: false,
				imgshow: false,
				baseURLSpe: sessionStorage.getItem("baseURLSpe") ? sessionStorage.getItem("baseURLSpe") : sessionStorage.getItem("baseURL"),
				images: [],
				fileObj: {},
				types: [{
						id: 1,
						name: '营业执照'
					},
					{
						id: 2,
						name: '施工资质'
					},
					{
						id: 3,
						name: '安全生产许可证'
					},
					{
						id: 4,
						name: '劳务合同'
					},
					{
						id: 5,
						name: '保险证明'
					},
					{
						id: 6,
						name: '项目管理人员资质'
					},
					{
						id: 7,
						name: '安全管理人员资质'
					},
					{
						id: 8,
						name: '主要施工设备资质'
					},
					{
						id: 9,
						name: '特殊工种人员证书'
					},
					{
						id: 10,
						name: '制度文件'
					},
					{
						id: 11,
						name: '其他必要资质文件'
					}
				],
				businessType: null,
				typeColumns: [{
					value: '2',
					text: '甲类'
				},{
					value: '1',
					text: '乙类'
				},{
					value: '3',
					text: '丙类'
				}],
				typeshow: false,
				stimeshow: false,
				etimeshow: false,
				isShow: false,
				obj: {
					contractNo: null,
					contractStime: null,
					contractEtime: null,
					businessType: null,
					orgName: null,
					orgAddr: null,
					orgCode: null,
					representative: null,
					person: null,
					phone: null,
					businessIntro: null,
					businessScope: null
				},
				errorMsg: {
					contractNo: null,
					contractStime: null,
					contractEtime: null,
					businessType: null,
					orgName: null,
					orgAddr: null,
					orgCode: null,
					representative: null,
					person: null,
					phone: null
				},
				rules: {
					// contractNo: [{
					// 	required: true,
					// 	message: '合同编号不能为空'
					// }],
					// contractStime: [{
					// 	required: true,
					// 	message: '开始时间不能为空'
					// }],
					// contractEtime: [{
					// 	required: true,
					// 	message: '结束时间不能为空'
					// }],
					// businessType: [{
					// 	required: true,
					// 	message: '业务类型不能为空'
					// }],
					orgName: [{
						required: true,
						message: '单位名称不能为空'
					}],
					orgAddr: [{
						required: true,
						message: '单位地址不能为空'
					}],
					orgCode: [{
						required: true,
						message: '组织机构代码不能为空'
					}],
					representative: [{
						required: true,
						message: '法人代表不能为空'
					}],
					person: [{
						required: true,
						message: '联系人不能为空'
					}],
					phone: [{
						required: true,
						message: '手机号不能为空'
					}, {
						validator: (rule, value, callback) => {
							if (!isMobile(value)) {
								this.errorMsg.phone = "请输入正确的手机号";
								callback('请输入正确的手机号');
							}
						}
					}]
				},
			}
		},
		created() {
			this.obj = this.$store.state.qy;
			if (this.obj.auditflag != null && this.obj.auditflag != 0) {
				this.readonly = true;
			}
			switch (this.obj.businessType) {
				case '1':
					this.businessType = "乙类"
					break;
				case '2':
					this.businessType = "甲类"
					break;
				case '3':
					this.businessType = "丙类"
					break;
			}
		},
		methods: {
			lookFlie(id) {
				// this.images = [this.$http.adornUrl('/mongodb/getDownloadOutputStream?fileId=' + id)];
				this.images = [this.baseURLSpe+'/mongodb/getDownloadOutputStream?fileId=' + id]
				this.imgshow = true;
			},
			onRead(file, detail) {
				let type = detail.name;
				let formdata = new FormData() // 创建form对象
				let filename = new Date().getTime()
				let arr = file.content.split(',')
				let mime = arr[0].match(/:(.*?);/)[1]
				let suffix = mime.split('/')[1]
				let bstr = atob(arr[1])
				let n = bstr.length
				let u8arr = new Uint8Array(n)
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n)
				}
				file = new File([u8arr], `${filename}.${suffix}`, {
					type: mime
				})
				formdata.append('file', file) // 通过append向form对象添加数据,可以通过append继续添加数//或formdata1.append('img',file);
				this.$http({
					url: this.$http.adornUrl('/mongodb/uploadFiles'),
					method: 'post',
					data: formdata,
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(data => {
					if (data && data.data.code === 1) {
						let fileid = data.data.data
						if (fileid != null && fileid.length > 0) {
							this.$http({
								url: this.$http.adornUrl('/mongodb/fileInfo/delFilesAndMongoByParentIdOROther'),
								method: 'post',
								data: this.$http.adornData({
									parentId: this.obj.id,
									fjSource: "相关方登记",
									type: type
								})
							}).then((res) => {
								if (res.data.code == 1) {
									let formData1 = new FormData();
									formData1.append("parentId", this.obj.id);
									formData1.append("id", fileid);
									formData1.append("fjSource", "相关方登记");
									formData1.append("type", type);
									this.$http({
										url: this.$http.adornUrl('/mongodb/fileInfo/uploadFiles'),
										method: 'post',
										data: formData1
									}).then((res1) => {
										this.tabClick(1, "单位资质")
										this.$toast({
											duration: 1000,
											message: '上传成功'
										})
									})
								}
							})
						}
					}
				})
			},
			async tabClick(index, title) {
				if (this.obj.id != null && this.obj.id.length > 0 && index > 0) {
					await this.$http({
						url: this.$http.adornUrl('/mongodb/fileInfo/getFileInfoList'),
						method: 'post',
						data: this.$http.adornData({
							"parentId": this.obj.id,
							"fjSource": "相关方登记"
						})
					}).then((res) => {
						if (res.data.code == 1) {
							let rows = res.data.data.rows;
							for (let i = 0; i < rows.length; i++) {
								let obj = {};
								obj['id'] = rows[i].id;
								obj['type'] = rows[i].attachType;
								this.fileObj[rows[i].type] = obj;
							}
						}
					})

					switch (this.obj.businessType) {
						case '1':
							this.types = [{
									id: 1,
									name: '营业执照'
								},
								{
									id: 2,
									name: '施工资质'
								},
								{
									id: 3,
									name: '安全生产许可证'
								},
								{
									id: 4,
									name: '劳务合同'
								},
								{
									id: 5,
									name: '保险证明'
								},
								{
									id: 6,
									name: '项目管理人员资质'
								},
								{
									id: 7,
									name: '安全管理人员资质'
								},
								{
									id: 8,
									name: '主要施工设备资质'
								},
								{
									id: 9,
									name: '特殊工种人员证书'
								},
								{
									id: 10,
									name: '制度文件'
								},
								{
									id: 11,
									name: '其他必要资质文件'
								}
							];
							break;
						case '2':
							this.types = [{
									id: 1,
									name: '营业执照'
								},
								{
									id: 2,
									name: '劳务合同'
								},
								{
									id: 3,
									name: '保险证明'
								},
								{
									id: 4,
									name: '制度、规程'
								},
								{
									id: 5,
									name: '危险源清单'
								},
								{
									id: 6,
									name: '隐患排查清单'
								},
								{
									id: 7,
									name: '应急预案'
								},
								{
									id: 8,
									name: '人员培训记录'
								},
								{
									id: 9,
									name: '安全管理人员资质'
								},
								{
									id: 10,
									name: '特种设备资质'
								},
								{
									id: 11,
									name: '特殊工种人员证书'
								},
								{
									id: 12,
									name: '其他必要资质文件'
								}
							];
							break;
						case '3':
							this.types = [{
									id: 1,
									name: '设备设施清单'
								},
								{
									id: 2,
									name: '建构筑清单'
								},
								{
									id: 3,
									name: '三同时文件'
								},
								{
									id: 4,
									name: '安全设施清单'
								},
								{
									id: 5,
									name: '其他必要资质文件'
								}
							];
							break;
						case '4':
							this.types = [{
									id: 1,
									name: '营业执照'
								},
								{
									id: 2,
									name: '劳务合同'
								},
								{
									id: 3,
									name: '保险证明'
								},
								{
									id: 4,
									name: '制度、规程'
								},
								{
									id: 5,
									name: '危险源清单'
								},
								{
									id: 6,
									name: '隐患排查清单'
								},
								{
									id: 7,
									name: '应急预案'
								},
								{
									id: 8,
									name: '人员培训记录'
								},
								{
									id: 9,
									name: '安全管理人员资质'
								},
								{
									id: 10,
									name: '特种设备资质'
								},
								{
									id: 11,
									name: '特殊工种人员证书'
								},
								{
									id: 12,
									name: '其他必要资质文件'
								}
							];
							break;
					}
				}
			},
			formatter(type, value) {
				if (type === 'year') {
					return `${value}年`;
				} else if (type === 'month') {
					return `${value}月`
				} else if (type === 'day') {
					return `${value}日`
				}
				return value;
			},
			stimeconfirm(v) {
				this.obj.contractStime = this.datetime.getDate("yyyy-MM-dd", v);
				this.stimeshow = false;
			},
			etimeconfirm(v) {
				this.obj.contractEtime = this.datetime.getDate("yyyy-MM-dd", v);
				this.etimeshow = false;
			},
			typeconfirm(v) {
				this.obj.businessType = v.value;
				this.businessType = v.text;
				this.typeshow = false;
			},
			// 校验函数
			validateFormFields() {
				let isPassValidateForm = true;
				validateForm(this.rules, this.obj, this.errorMsg, (errors, fields) => {
					isPassValidateForm = errors
				})
				return isPassValidateForm;
			},
			async validateContractNo() {
				let r = true;
				await this.$http({
					url: this.$http.adornUrl('/safe/tbQybaseinfoRelated/listPageRelated'),
					method: 'post',
					data: this.$http.adornData({
						contractNo: this.obj.contractNo,
						orgCode: this.obj.orgCode
					})
				}).then(({
					data
				}) => {
					if (data && data.code === 1) {
						if (data.data.rows != null && data.data.rows.length > 0) {
							this.errorMsg.contractNo = '该合同编号已存在'
							r = false;
						} else {
							this.errorMsg.contractNo = null;
							r = true;
						}
					} else {
						r = false;
					}
				}).catch(() => {
					r = false;
				})
				return r;
			},
			async submitInfo() {
				if (!this.validateFormFields()) {
					let vcn = await this.validateContractNo();
					if (vcn) {
						this.$http({
							url: this.$http.adornUrl('/safe/tbQybaseinfoRelated/save'),
							method: 'post',
							data: this.$http.adornData(this.obj)
						}).then((res) => {
							if (res.data.code == 1 && res.data.data != null) {
								this.obj = res.data.data;
								this.$toast({
									duration: 1000,
									message: '单位信息保存成功'
								})
							} else {
								this.$toast({
									duration: 1000,
									message: '单位信息保存失败'
								})
							}
						})
					}
				}
			},
			submitFile() {
				this.$dialog.confirm({
					message: '请确定您的文件全部已上传完成！'
				}).then(() => {
					let loadingtoast = this.$toast({
						type: "loading",
						mask: true,
						duration: "toast",
						message: '提交中...'
					});
					this.$http({
						url: this.$http.adornUrl('/safe/tbQybaseinfoRelated/updateAuditById'),
						method: 'post',
						data: this.$http.adornData({
							id: this.obj.id,
							auditflag: 3
						})
					}).then((res) => {
						if (res.data.code == 1) {
							loadingtoast.clear();
							this.$router.go(-1);
							this.$toast({
								duration: 1000,
								message: '提交成功'
							})
						}
					})
				}).catch(() => {
					// on cancel
				});
			}

		},
		components: {
			NavHeader
		},
	}
</script>

<style lang="less" scoped>
	.unitDetail {
		width: 100%;
		margin: 0 auto;
		overflow: auto !important;
		button{
			width: 100%;
			color: #fff;
		}
		.van-tabs--line {
			background: #fff;
		}

		.van-cell-group {
			padding: 0 12px;
			margin-top: 0;

			.van-field {
				border-bottom: 1px solid #ececec;
			}

			.van-cell {
				border-bottom: 1px solid #ececec;

				.van-cell__value {
					span {
						height: 6vw;
						border: 1px solid #ec0000;
						border-radius: 4px;
						color: #ec0000;
						line-height: 6vw;
						padding: 1px 4px;
					}
				}
			}

			.van-row {
				/* width: 94%;
      	margin-left: 6%; */

				.van-cell__title i {
					font-style: normal;
					color: #ee0a24;
					margin-right: 4px;
				}

			}

		}
	}
</style>
